import {
  FormattedMentimeterPlanNames,
  FormattedPlanNames,
} from '@mentimeter/billing';

export const getFormattedPlanName = (
  category: string | undefined,
  includeMentimeterInName: boolean,
): string => {
  if (!category) return 'Mentimeter';

  if (includeMentimeterInName) {
    return (
      FormattedMentimeterPlanNames[
        category as keyof typeof FormattedMentimeterPlanNames
      ] || 'Mentimeter'
    );
  }

  return (
    FormattedPlanNames[category as keyof typeof FormattedPlanNames] ||
    'Mentimeter'
  );
};
